/**
 * Shared query cache keys used by multiple features.
 *
 * Cross-feature imports are forbidden (ESLint import-x/no-restricted-paths).
 * Any key required by 2+ features must live here so both can import from src/lib/.
 * The reservation and media-unit availability prefixes are owned by @ooh/screens, whose mutations invalidate them.
 */

/** Cache key for the active-tag-definitions list fetched by the media-unit picker. */
export const TAG_LIST_QUERY_KEY = ['media-units', 'tag-definitions', 'active'] as const;

export { MEDIA_UNIT_AVAILABILITY_KEY_PREFIX, RESERVATION_LIST_KEY_PREFIX } from '@ooh/screens';
